// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2HNuy","header":"PatientQuestionnaire_header__2IaT6","info":"PatientQuestionnaire_info__1YA0y"};